<template>

    <my-bookings />

</template>

<script>

    import MyBookings from '../components/home/MyBookings.vue'
    
    export default {

        components: {
            MyBookings
        }
        
    }

</script>